import { Navigate, Route, Routes } from 'react-router';
import { useMe } from './lib/session';
import { SignInPage } from './pages/SignInPage';
import { StudentHomePage } from './pages/student/StudentHomePage';
import { LessonPage } from './pages/student/LessonPage';
import { StaffHomePage } from './pages/staff/StaffHomePage';
import { Spinner } from './ui';
import type { ReactNode } from 'react';

function Gate({ need, children }: { need: 'student' | 'staff'; children: ReactNode }) {
  const me = useMe();
  if (me.isLoading) return <Spinner />;
  const m = me.data;
  if (!m) return <Navigate to="/sign-in" replace />;
  if (need === 'student' && m.kind !== 'student') return <Navigate to="/" replace />;
  if (need === 'staff' && (m.kind !== 'staff' || m.stage === 'mfa')) return <Navigate to="/sign-in" replace />;
  return <>{children}</>;
}

function Home() {
  const me = useMe();
  if (me.isLoading) return <Spinner />;
  const m = me.data;
  if (!m) return <Navigate to="/sign-in" replace />;
  if (m.kind === 'student') return <Navigate to="/learn" replace />;
  if (m.stage === 'mfa') return <Navigate to="/sign-in" replace />;
  return <Navigate to="/staff" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/learn" element={<Gate need="student"><StudentHomePage /></Gate>} />
      <Route path="/learn/lesson/:lessonId" element={<Gate need="student"><LessonPage /></Gate>} />
      <Route path="/staff" element={<Gate need="staff"><StaffHomePage /></Gate>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
